
<div>
	<!-- <v-container align="center" justify="center" class="pa-5 pb-0">
		<ImageUploadAndCrop v-show="showCropper" :image="cropperImage" />
	</v-container> -->

	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-dialog v-model="avatarModel" width="500">
			<v-card>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="avatarModel = false"> Close </v-btn>
				</v-card-actions>
				<v-container align="center" justify="center">
					<v-img :src="avatarfilepreview"></v-img>
				</v-container>
			</v-card>
		</v-dialog>
	</v-container>

	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"><h1>About you</h1></v-list-item-title>
				<v-list-item-subtitle class="text-center text-wrap">Make your first impression 😊</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-container>
		<v-form ref="locumAboutYouForm" class="pa-4 pb-1 pt-0">
			<v-card-text align="center" justify="center" class="justify-center text-left pb-0 pm-0">
				<v-row class="justify-center text-center pt-0 pb-0">
					<v-col>
						<v-avatar v-ripple class="justify-center text-center" :size="150" style="margin: auto" color="#F4F4F4" @click="avatarModel = true">
							<v-img :src="avatarfilepreview" alt="" :max-width="150" class="mx-auto"></v-img>
						</v-avatar>
					</v-col>
				</v-row>
				<v-row class="justify-center text-center" style="color: var(--v-primary-base)"
					><v-col style="color: primary; text-transform: none !important"
						><v-btn class="text-none text-wrap" text style="color: var(--v-primary-base)">
							<v-file-input
								ref="uploader"
								v-model="contentMedia"
								:class="{ 'body-1': $vuetify.breakpoint.mdAndUp, caption: $vuetify.breakpoint.smAndDown, 'custom-file-uploader': true }"
								accept=".png, .jpg, .jpeg, .gif, .pdf"
								placeholder="Upload a profile picture"
								show-size
								:truncate-length="15"
								:prepend-icon="''"
								:rules="imgRules"
								prepend-inner-icon="cloud_upload"
								style="color: var(--v-primary-base); border: none"
							/>
						</v-btn> </v-col
				></v-row>
				<v-row class="justify-center text-center">
					<v-col class="error--text">
						<v-card-text v-show="avatarError">Please upload a professional picture</v-card-text>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-textarea :rules="short_bioRules" outlined placeholder="Write your bio here." :value="short_bio" @change="change_bio"> </v-textarea>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-select v-model="languages_selected" :rules="languageRules" :items="languages" multiple outlined chips placeholder="Select the languages you speak">
						</v-select>
					</v-col>
				</v-row>

				<v-row align="center" justify="center">
					<v-col align="center" justify="center" :cols="7">
						<DistinctYesNo :initial="hasIndemnity" :errors="indemnityYesNoErrors" @input="OnIndemnity">
							{{ getLabel('aboutSectionFileUploadTitle', 'Do you have Professional Indemnity Insurance?') }}
						</DistinctYesNo>
					</v-col>
				</v-row>

				<v-col :cols="12">
					<div v-show="hasIndemnity == 'yes'">
						<v-file-input
							:label="labelIndemnity"
							:persistent-hint="true"
							:class="{ 'custom-file-uploader': true }"
							:prepend-icon="''"
							prepend-inner-icon="cloud_upload"
							:dense="true"
							outlined
							chips
							show-size
							:error-messages="indemnityInputError"
							@change="handleIndemnityFile"
						></v-file-input>
						<span v-if="docExists('indemnityInsuranceFile')">Indemnity document already uploaded. Click above to upload a new document.</span>

						<!-- <v-card-text align="center" justify="center" class="justify-center text-center px-0">
							<v-menu v-model="insuranceExpiryMenu" offset-y :close-on-content-click="false" transition="scale-transition">
								<template #activator="{ on }">
									<v-text-field
										v-model="textDisplayExpiryDate"
										outlined
										class="pb-3"
										label="Select Professional Indemnity Insurance expiry date"
										append-icon="event"
										hint="Select or type the date (DD/MM/YYYY)"
										persistent-hint
										:rules="insuranceExpiryRules"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker v-model="insuranceExpiry" :min="new Date().toISOString()" no-title @input="insuranceExpiryMenu = false"></v-date-picker>
							</v-menu>
						</v-card-text> -->
					</div>
				</v-col>
			</v-card-text>
		</v-form>
	</v-container>
</div>
